import { useState } from 'react';
import { faqs } from '@/mocks/videos';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="w-full bg-background-50 py-10 md:py-14">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-2">
            常见问题
          </h2>
          <p className="text-sm text-foreground-500">
            关于蜜桃视频，你想知道的都在这里
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="rounded-xl bg-background-100 overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between p-4 md:p-5 text-left cursor-pointer hover:bg-background-200 transition-colors"
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
              >
                <h4 className="text-sm font-semibold text-foreground-900 pr-4">
                  {faq.question}
                </h4>
                <div className={`w-6 h-6 rounded-full flex items-center justify-center flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180 bg-primary-500' : 'bg-background-300'}`}>
                  <i className={`text-xs ${openIndex === index ? 'ri-subtract-line text-background-50' : 'ri-add-line text-foreground-600'}`}></i>
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <p className="px-4 md:px-5 pb-4 md:pb-5 text-sm text-foreground-600 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}